import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import LatestSection from './components/LatestSection';
import PopularSection from './components/PopularSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEOHead
        title="韩漫在线 - 韩漫下拉式在线阅读 - 免费韩国漫画大全 - 奇漫屋"
        description="奇漫屋提供免费韩国漫画大全，支持在线和下拉式阅读，您能随时访问最新韩漫资源，体验便捷的浏览方式，发现无数精彩故事等待您的探索。"
        keywords="韩漫在线, 下拉式阅读, 免费韩国漫画, 奇漫屋, 韩国漫画"
        canonicalUrl="https://qimanwu.com"
      />
      <SchemaOrg
        type="WebPage"
        pageUrl="https://qimanwu.com"
        pageName="奇漫屋 - 免费韩国漫画在线阅读平台"
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <HeroSection />
          <CategorySection />
          <PopularSection />
          <LatestSection />
          <FAQSection />

          <section className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16 text-center">
            <div className="bg-gradient-to-r from-primary-500 to-accent-500 rounded-2xl p-10 md:p-14">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
                开启你的韩漫之旅
              </h2>
              <p className="text-sm text-background-200 max-w-lg mx-auto mb-6">
                加入奇漫屋，畅享海量免费韩国漫画，每日更新，精彩不断
              </p>
              <Link
                to="/category/all"
                className="inline-flex items-center gap-2 px-8 py-3 bg-background-50 text-primary-600 text-sm font-semibold rounded-full cursor-pointer hover:bg-background-100 transition-all whitespace-nowrap"
              >
                立即开始阅读
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}